export function track(eventName: string) {
  const win = window as any;
  if (win.umami && typeof win.umami.track === 'function') {
    win.umami.track(eventName);
  }
}
